import {initializeApp} from "firebase/app";
import {getDatabase} from "firebase/database"
import {getAuth} from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: `${process.env.firebaseApiKey}`,
    authDomain: `${process.env.firebaseAuthDomain}`,
    projectId: `${process.env.firebaseProjectId}`,
    storageBucket: `${process.env.firebaseStorageBucket}`,
    messagingSenderId: `${process.env.firebaseMessagingSenderId}`,
    appId: `${process.env.firebaseAppId}`,
    measurementId: `${process.env.firebaseMeasurementId}`
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app)
const auth = getAuth(app)

export {app, db, auth}